document.addEventListener("DOMContentLoaded", function () {
  const sentence = "True Focus ";
  const blurAmount = 8;
  const borderColor = "#38b6ff";
  const glowColor = "#38b6ff";
  const animationDuration = 500; // Milisegundos
  const pauseBetweenAnimations = 500; // Milisegundos
  

  const container = document.getElementById("true-focus-container");

  if (!container) return;

  const words = sentence.split(" ");
  container.innerHTML = words
    .map((word, index) => `<span class="focus-word" id="word-${index}">${word}</span>`)
    .join(" ");

  let currentIndex = 0;

  function highlightWord() {
    document.querySelectorAll(".focus-word").forEach((el) => {
      el.style.filter = `blur(${blurAmount}px)`;
      el.style.borderBottom = "none";
    });

    const activeWord = document.getElementById(`word-${currentIndex}`);
    if (activeWord) {
      activeWord.style.filter = "none";
      activeWord.style.borderBottom = `2px solid ${borderColor}`;
      activeWord.style.textShadow = `0 0 10px ${glowColor}`;
    }

    currentIndex = (currentIndex + 1) % words.length;
  }

  setInterval(highlightWord, animationDuration + pauseBetweenAnimations);
  highlightWord();
});
